import { render, staticRenderFns } from "./MenuBlock.vue?vue&type=template&id=10335b49&scoped=true&"
import script from "./MenuBlock.vue?vue&type=script&lang=js&"
export * from "./MenuBlock.vue?vue&type=script&lang=js&"
import style0 from "./MenuBlock.vue?vue&type=style&index=0&id=10335b49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10335b49",
  null
  
)

export default component.exports